import { Select } from 'antd';
import React from 'react';
import iconAmazon from './../../../../../../resources/imgs/amazon.png';
import './styles.css';
import { listChannel } from './../../../../../../utils/channel'
import handleException from './../../../../../../services/handleException'
import { getImageChannel } from './../../../../../../constants/order'
import { alertError } from './../../../../../../services/dialog'
import lang from './../../../../../../languages/en'

const Option = Select.Option

const data = [{
    key: '1',
    channel: <img className="icon-amazon" src={iconAmazon} />,
    active: 'Yes'
},];

class ChannelTableProhibitedItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           currentChannelName: ''
        };
    }

    componentDidMount() {
        let _this = this;
        listChannel().then(res => {
            if(res.data.code === 10001) {
                let listChannel = []
                if(Object.keys(res.data.data).length && res.data.data.channels.length) {
                    listChannel = res.data.data.channels
                    for (let key in listChannel) {
                        let itemChannel = listChannel[key];
                        if (itemChannel.ID == _this.props.channelActive) {
                            _this.setState({
                                currentChannelName: itemChannel.Name
                            })
                        }
                    }
                }
            } else {
                handleException(res)
            }
        }).catch(err => {
            handleException(err)
        })
    }

   
    render() {
        return (
            <div id="ChannelTableProhibited">
                { getImageChannel(this.state.currentChannelName)}
            </div>
        )
    }
}
export default ChannelTableProhibitedItem


// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/prohibited-items/channel-table-prohihited-items/index.js